/**
 * Created by Rodrigo Quesada on 28/12/16.
 */
import {Injectable, OpaqueToken, Inject} from '@angular/core';
import {Routes, Router, NavigationEnd} from '@angular/router';
import {Observable} from 'rxjs';
import {NavigableNodeDeps} from './navigable-node.class';
import {SectionsServiceNode} from './sections-service-node.class';

export let SECTION_ROUTES = new OpaqueToken('section-routes');

export const RouteConfig = {
    SECTION: 'section',
    STEP: 'step',
    SCREEN: 'screen'
};

@Injectable()
export class SectionsService {

    refreshed$: Observable<boolean>;

    private _root: SectionsServiceNode;

    get currentSectionStepNumber(): number {
        return this._root.currentSectionStepNumber;
    }

    get currentSectionStepsProgress(): number {
        return this._root.currentSectionStepsProgress;
    }

    get currentSectionTitle(): string {
        return this._root.currentSectionTitle;
    }

    constructor(@Inject(SECTION_ROUTES) routes: Routes,
                private readonly _router: Router,
                navigableNodeDeps: NavigableNodeDeps) {

        SectionsServiceNode.fromRoutes(navigableNodeDeps, routes).first().subscribe(node => {
            node.init();
            this._root = node;
            this.refreshed$ = node.refreshed$;

            this._rootRoute$().subscribe(rootRoute => this._root.refreshCurrentSection(rootRoute));
        });
    }

    private _rootRoute$() {
        return this._router.events
            .filter(event => event instanceof NavigationEnd)
            .map(() => this._router.routerState.root);
    }

    hasPreviousScreen(): boolean {
        return this._root.hasPreviousLeaf();
    }

    goToPreviousScreen(): Observable<boolean> {
        if (this._root.hasPreviousLeaf()) return this._root.navigateToPreviousLeaf();
        else return Observable.empty();
    }

    hasNextScreen(): boolean {
        return this._root.hasNextLeaf();
    }

    goToNextScreen(): Observable<boolean> {
        if (this._root.hasNextLeaf()) return this._root.navigateToNextLeaf();
        else return Observable.empty();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/sections/service/sections.service.ts